import React, { useState } from 'react';
import content from '../../translations/content.json';
import './style.css';

export const TrustedLogos = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const { logos } = content;

  const enterpriseStyles = [
    "font-black italic tracking-wider text-xl text-[#0B1B3D]",
    "font-black italic tracking-wider text-xl text-[#0B1B3D]",
    "font-black tracking-wider text-xl text-[#0B1B3D]",
    "font-black italic tracking-wider text-xl text-blue-800",
  ];

  const enterprises = logos.items.map((item, index) => ({
    ...item,
    style: enterpriseStyles[index % enterpriseStyles.length],
  }));

  const marqueeItems = [...enterprises, ...enterprises, ...enterprises];

  return (
    <section className="w-full py-12 bg-slate-50/50 overflow-hidden border-y border-slate-100">
      <h3 className="text-[15px] font-black tracking-[0.15em] text-[#1E1B4B] uppercase text-center mb-8">
        {logos.title}
      </h3>
      <div className="relative w-full overflow-hidden group" data-testid="marquee-wrapper">
        <div className="flex w-max animate-marquee group-hover:[animation-play-state:paused]" data-testid="marquee-track">
          {marqueeItems.map((item, index) => {
            let cardClassName = 'flex items-center gap-4 px-8 py-4 mx-4 rounded-2xl bg-white border border-slate-200/80 shadow-sm transition-all duration-300 cursor-pointer shrink-0';
            if (hoveredIndex !== null) {
              if (hoveredIndex === index) {
                cardClassName += ' ring-2 ring-purple-500 shadow-lg scale-105 bg-white';
              } else {
                cardClassName += ' opacity-30 scale-95';
              }
            }

            return (
              <div
                key={index}
                data-testid={`logo-card-${index}`}
                onMouseEnter={() => setHoveredIndex(index)}
                onMouseLeave={() => setHoveredIndex(null)}
                className={cardClassName}
              >
                <div className={`shrink-0 ${item.style} blur-text`}>{item.name}</div>
                <div className="w-[1px] h-8 bg-slate-200 mx-2" />
                <div className="text-[11px] font-medium text-slate-600 leading-snug max-w-[180px]">
                  {item.subtitle}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
